import { axios } from "@Root/API";

export const deleteAdminProgrammeType = programmeTypeId => {
  return axios.delete(`program-type/${programmeTypeId}/delete`);
};
